import { InnerPackagingModel } from './inner-packaging.model';
import { EnumPackageType } from './package-type.enum';
import { PackagingModel } from './packaging.model';

export class CompositePackagingModel extends PackagingModel {
  override PackageType = EnumPackageType.CompositePacking;
  Items: InnerPackagingModel[] = [];
  GrossWeightValue = '';
  GrossWeightUnitSymbol = 'kg';
  IsTotalQuantity = false;
  CurrentInnerPackaging?: InnerPackagingModel;
}
